// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Setting__title-dd46c9 {
  color: var(--base-80);
  font: var(--font-subtitle-3);
  letter-spacing: var(----font-spacing-subtitle-3);
  padding: 16px 16px 0 16px;
}`, "",{"version":3,"sources":["webpack://./src/main/Calendar/Content/Toolbar/Setting/ExternalEmails.styles.m.css"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,4BAAA;EACA,gDAAA;EACA,yBAAA;AACF","sourcesContent":[".title {\n  color: var(--base-80);\n  font: var(--font-subtitle-3);\n  letter-spacing: var(----font-spacing-subtitle-3);\n  padding: 16px 16px 0 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `Setting__title-dd46c9`
};
module.exports = ___CSS_LOADER_EXPORT___;
